/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：29
 */

module.exports = {
  hide: "style_hide__xbMGj",
  "coco-widget-wrapper": "style_coco-widget-wrapper__2QHeH",
  "coco-child-widget": "style_coco-child-widget__3Ty5d",
  "coco-child-widget-selected": "style_coco-child-widget-selected__6dONS",
  "coco-child-widget-full": "style_coco-child-widget-full__wKqkZ",
  flexSC: "style_flexSC__3puyC",
  flexCC: "style_flexCC__bfcgk",
  flexLC: "style_flexLC__2eEwz",
  icon: "style_icon___wwbG",
  itemTiled: "style_itemTiled__2kkMG",
  itemCard: "style_itemCard__3Anwe",
  listViewerBox: "style_listViewerBox__2s1Ku",
  templateSlot: "style_templateSlot__2rYHs",
  template1: "style_template1__2XEN-",
  title: "style_title__32L4i",
  titleSlot: "style_titleSlot__3Daky",
  iconBox: "style_iconBox__3rk1k",
  template2: "style_template2__v3Im5",
  subTitleBox: "style_subTitleBox__2B9gc",
  subTitle: "style_subTitle__3cYm2",
  subTitleSlot: "style_subTitleSlot__3WzuE",
  template3: "style_template3__1Pz9H",
  smallImgBox: "style_smallImgBox__1jSTa",
  smallImgSlot: "style_smallImgSlot__1d6Xx",
  template4: "style_template4__3B2se",
  avatarAndTitle: "style_avatarAndTitle__2xROs",
  avatarImgBox: "style_avatarImgBox__2c3Zm",
  avatarImgSlot: "style_avatarImgSlot__1Qh5W",
  template5: "style_template5__Ayk7Z",
  imgAndTitleBox: "style_imgAndTitleBox__2rs5w",
  desc: "style_desc__3PxGW",
  titleSlot1: "style_titleSlot1__1Di1P",
  titleSlot2: "style_titleSlot2__1H_uo",
  descSlot: "style_descSlot__wATUS",
  template6: "style_template6__Ezw69",
  bannerImgBox: "style_bannerImgBox__19zO-",
  bannerImgSlot: "style_bannerImgSlot__28S_8",
  descSlot1: "style_descSlot1__35eTr",
  descSlot2: "style_descSlot2__3wSkr"
}
